<div #container [ngClass]="{'ets-hidden': !isActive}" class="panel-container">

  <!-- OPG CoPilot launcher (CR-20260710-001; A7 / WI-11) — family FAB (brain icon). Default rests at the
       WHOLE-PANEL bottom-right (anchored to .panel-container, NOT the grid .board) so it clears the strike
       ladder; draggable anywhere inside the panel via etsDraggable. copilotFabPosition is session-only and
       lives on the component, so a moved FAB survives its own *ngIf teardown when the popup opens/closes.
       Hidden while the window is open. Entitlement + mode gated: no grant -> no trace (§10); never on the
       Position Modifier ('pmd'). -->
  <button type="button"
          class="copilot-fab"
          data-element="copilot-fab"
          *ngIf="this.isOpgCoPilotAvailable() && !this.copilotPopupVisible"
          [class.is-stale]="this.copilotIsStale"
          etsDraggable
          [etsDraggablePosition]="this.copilotFabPosition"
          (etsDraggablePositionChange)="this.copilotFabPosition = $event"
          (click)="this.openOpgCopilot()">
    <i class="fas fa-brain"></i>
    <span>ORION</span>
  </button>

  <div class="split">
    
    <div [ngClass]="{'collapsed': !this.callsSidePanelVisible}" class="side-panel calls">
      <ng-container *ngTemplateOutlet="sidePanel; context: {$implicit: {header: 'CALLS', targetSide: 'calls' }}">
      </ng-container>
    </div>
    
    <div class="center">
      
      <div class="control-panel">

        <div class="tb-grid">

          <div class="tb-row tb-row-top">

            <div class="tb-col tb-col-a">
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('underlying')">
                <ets-symbol-picker (instrumentSelected)="this.onSymbolSelected($event)"
                                   [disabled]="!this.canChangeUnderlying()"
                                   [selectedInstrument]="this.tradingInstrument">
                </ets-symbol-picker>
              </div>
            </div>

            <div class="tb-col tb-col-b">
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('expiration')">
                <p class="label">Expiration</p>
                <ets-expiration-selector
                  (expirationChanged)="this.onExpirationSelected($event)"
                  [(selectedExpiration)]="this.selectedExpiration"
                  [expirationDescriptors]="this.availableExpirations"
                  [disabled]="!this.tradingInstrument || !this.canChangeExpiration()">
                </ets-expiration-selector>
              </div>
            </div>

            <div class="tb-col tb-col-c">
              <div class="tb-slot ets-dx-number" [class.element-hidden]="!this.isElementVisible('strike-step')">
                <p class="label">Strike Step</p>
                <dx-number-box
                  (onValueChanged)="this.onStrikeStepChanged($event)"
                  [(value)]="this.strikeStep"
                  [disabled]="!this.subControlsEnabled" [min]="this.strikeLadderStep"
                  [showSpinButtons]="true" [step]="this.strikeLadderStep"
                  [useLargeSpinButtons]="false"></dx-number-box>
              </div>
            </div>

            <div class="tb-col tb-col-d">
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('atm-strike')">
                <p class="label">ATM Strike</p>
                <ets-strikes-dropdown
                  (strikeChanged)="this.onCustomAtmStrikeChanged($event)"
                  [expiration]="this.expiration"
                  [showClearButton]="true"
                  [strike]="this.atmStrike"
                  [targetInstrument]="this.tradingInstrument">
                </ets-strikes-dropdown>
              </div>
              <div class="tb-slot ets-dx-number" [class.element-hidden]="!this.isElementVisible('num-of-strikes')">
                <p class="label"># of Strikes</p>
                <dx-number-box
                  (onValueChanged)="this.onStrikesNumberChanged($event)"
                  [(value)]="this.numOfStrikes"
                  [disabled]="!this.subControlsEnabled"
                  [inputAttr]="{'style': 'text-align: center'}" [min]="0"
                  [showSpinButtons]="true"
                  [useLargeSpinButtons]="false">
                </dx-number-box>
              </div>
            </div>

            <div class="tb-col tb-col-e">
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('call-offset')">
                <ng-container *ngIf="!this.isCustomRange">
                  <p class="label">Call Offset</p>
                  <dx-number-box
                    (onValueChanged)="this.onTargetRangeChanged()"
                    [(value)]="this.callOffset"
                    [disabled]="this.pricingRows.length === 0 || !this.subControlsEnabled"
                    [inputAttr]="{style: 'text-align: center'}"
                    [showClearButton]="true">
                  </dx-number-box>
                </ng-container>
                <ng-container *ngIf="this.isCustomRange">
                  <p class="label">C. Range Start</p>
                  <ets-strikes-dropdown
                    (strikeChanged)="this.onTargetRangeChanged()"
                    [(strike)]="this.callsTargetRangeStart"
                    [disable]="this.pricingRows.length === 0 || !this.subControlsEnabled"
                    [expiration]="this.expiration"
                    [showClearButton]="true"
                    [targetInstrument]="this.tradingInstrument">
                  </ets-strikes-dropdown>
                </ng-container>
              </div>
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('call-range')">
                <ng-container *ngIf="!this.isCustomRange">
                  <p class="label">Call Range</p>
                  <dx-number-box
                    (onValueChanged)="this.onTargetRangeChanged()"
                    [(value)]="this.callRange"
                    [disabled]="this.pricingRows.length === 0 || !this.subControlsEnabled"
                    [inputAttr]="{style: 'text-align: center'}"
                    [showClearButton]="true">
                  </dx-number-box>
                </ng-container>
                <ng-container *ngIf="this.isCustomRange">
                  <p class="label">C. Range End</p>
                  <ets-strikes-dropdown
                    (strikeChanged)="this.onTargetRangeChanged()"
                    [(strike)]="this.callsTargetRangeEnd"
                    [disable]="this.pricingRows.length === 0 || !this.subControlsEnabled"
                    [expiration]="this.expiration"
                    [showClearButton]="true"
                    [targetInstrument]="this.tradingInstrument">
                  </ets-strikes-dropdown>
                </ng-container>
              </div>
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('put-offset')">
                <ng-container *ngIf="!this.isCustomRange">
                  <p class="label">Put Offset</p>
                  <dx-number-box
                    (onValueChanged)="this.onTargetRangeChanged()"
                    [(value)]="this.putOffset"
                    [disabled]="this.pricingRows.length === 0 || !this.subControlsEnabled"
                    [inputAttr]="{style: 'text-align: center'}"
                    [showClearButton]="true">
                  </dx-number-box>
                </ng-container>
                <ng-container *ngIf="this.isCustomRange">
                  <p class="label">P. Range Start</p>
                  <ets-strikes-dropdown
                    (strikeChanged)="this.onTargetRangeChanged()"
                    [(strike)]="this.putsTargetRangeStart"
                    [disable]="this.pricingRows.length === 0 || !this.subControlsEnabled"
                    [expiration]="this.expiration"
                    [showClearButton]="true"
                    [targetInstrument]="this.tradingInstrument">
                  </ets-strikes-dropdown>
                </ng-container>
              </div>
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('put-range')">
                <ng-container *ngIf="!this.isCustomRange">
                  <p class="label">Put Range</p>
                  <dx-number-box
                    (onValueChanged)="this.onTargetRangeChanged()"
                    [(value)]="this.putRange"
                    [disabled]="this.pricingRows.length === 0 || !this.subControlsEnabled"
                    [inputAttr]="{style: 'text-align: center'}"
                    [showClearButton]="true">
                  </dx-number-box>
                </ng-container>
                <ng-container *ngIf="this.isCustomRange">
                  <p class="label">P. Range End</p>
                  <ets-strikes-dropdown
                    (strikeChanged)="this.onTargetRangeChanged()"
                    [(strike)]="this.putsTargetRangeEnd"
                    [disable]="this.pricingRows.length === 0 || !this.subControlsEnabled"
                    [expiration]="this.expiration"
                    [showClearButton]="true"
                    [targetInstrument]="this.tradingInstrument">
                  </ets-strikes-dropdown>
                </ng-container>
              </div>
            </div>

            <div class="tb-col tb-col-f" *ngIf="this.mode === 'opg'">
              <div class="tb-slot ets-dx-number" [class.element-hidden]="!this.isElementVisible('percentage-profit')">
                <p class="label">% - Profit</p>
                <dx-number-box
                  (onValueChanged)="this.onPercentProfitChanged($event)"
                  [(value)]="this.percentageProfit"
                  [disabled]="this.pricingRows.length === 0 || !this.subControlsEnabled" [min]="0"
                  [showSpinButtons]="true" [step]="1"
                  [useLargeSpinButtons]="false"></dx-number-box>
              </div>
            </div>

            <div class="tb-col tb-col-g" *ngIf="this.mode === 'opg'">
              <div class="tb-slot ets-dx-number" [class.element-hidden]="!this.isElementVisible('r-multiple')">
                <p class="label">R Multiple</p>
                <dx-number-box
                  (onValueChanged)="this.onRMultipleChanged($event)"
                  [(value)]="this.rMultiple"
                  [disabled]="!this.subControlsEnabled"
                  [inputAttr]="{'style': 'text-align: center'}"
                  [min]="1" [showSpinButtons]="true"
                  [step]="0.1" [useLargeSpinButtons]="false"></dx-number-box>
              </div>
            </div>

            <div class="tb-col tb-col-h">
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('itm-data')">
                <p class="label">ITM<br>Data</p>
                <dx-check-box
                  (onValueChanged)="this.onShowItmDataChanged($event)"
                  [(value)]="this.showItmData"
                  [disabled]="!this.subControlsEnabled || this.pricingMode">
                </dx-check-box>
              </div>
            </div>

          </div>

          <div class="tb-row tb-row-bottom">

            <div class="tb-col tb-col-a">
              <div class="tb-slot"
                   [class.tb-inline]="!this.isEsFuturesUnderlying"
                   [class.element-hidden]="!this.isElementVisible('default-qty')">
                <p class="label">Default Qty</p>
                <dx-number-box (onValueChanged)="this.onDefaultQtyChanged($event)"
                               [(value)]="this.defaultQty"
                               [inputAttr]="{style: 'text-align: center;'}"
                               [min]="1">
                </dx-number-box>
              </div>
              <div class="tb-slot" *ngIf="this.isEsFuturesUnderlying" [class.element-hidden]="!this.isElementVisible('hedge-mode')">
                <dx-check-box [(value)]="this.hedgingMode" text="Hedge Mode"
                              (onValueChanged)="this.onHedgingModeChanged($event)">
                </dx-check-box>
              </div>
            </div>

            <div class="tb-col tb-col-b">
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('auto-size')">
                <dx-check-box [(value)]="this.autoScrollToTargetSide" text="Auto-Scroll"></dx-check-box>
              </div>
            </div>

            <div class="tb-col tb-col-c">
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('pnl')">
                <dx-check-box [(value)]="this.showPnl" text="P&L"
                              (onValueChanged)="this.onShowPnlChanged($event)">
                </dx-check-box>
              </div>
            </div>

            <div class="tb-col tb-col-d">
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('total-pnl')">
                <dx-check-box [(value)]="this.showPnl2" text="Total P&L"
                              (onValueChanged)="this.onShowPnl2Changed($event)">
                </dx-check-box>
              </div>
            </div>

            <div class="tb-col tb-col-e">
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('prop-to-puts')">
                <dx-check-box
                  (onValueChanged)="this.togglePropagateRange('calls')"
                  [(value)]="this.callsPropagateRange"
                  text="Prop. To Puts">
                </dx-check-box>
              </div>
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('custom-range')">
                <dx-check-box
                  (onValueChanged)="this.onTargetRangeChanged()"
                  [(value)]="this.isCustomRange"
                  text="Custom Range">
                </dx-check-box>
              </div>
              <div class="tb-slot" [class.element-hidden]="!this.isElementVisible('prop-to-calls')">
                <dx-check-box
                  (onValueChanged)="this.togglePropagateRange('puts')"
                  [(value)]="this.putsPropagateRange"
                  text="Prop. To Calls">
                </dx-check-box>
              </div>
            </div>

            <div class="tb-col tb-col-f" *ngIf="this.mode === 'opg'">
              <div class="tb-slot pricing-mode-slot" [class.element-hidden]="!this.isElementVisible('pricing-mode')">
                <dx-check-box
                  (onValueChanged)="this.onPricingModeChanged($event)"
                  [(value)]="this.pricingMode"
                  [disabled]="!this.subControlsEnabled"
                  text="Pricing Mode">
                </dx-check-box>
              </div>
            </div>

            <div class="tb-col tb-col-gh">
              <!-- The IV and H-Skew readings moved to the CALLS/PUTS side-panel headers
                   (owner, 2026-07-02 R9). -->
              <div class="tb-kebab-btn"
                   title="Toolbar Elements"
                   (click)="this.openToolbarVisibilityDialog()">⋮</div>
            </div>

          </div>

        </div>

      </div>
      
      <hr class="separator"/>
      
      <div class="board">
        <!-- OPG CoPilot launcher moved to .panel-container (whole-panel bottom-right, draggable) — see A7/WI-11 comment there. -->
        <div class="floating-price" *ngIf="this.showTotalCostFloater">
          <span class="label">Total Price:&nbsp;</span>
          <span [ngClass]="this.getTotalCostCssClasses()">
            {{ this.getTotalCost() | currency:'USD':'$':'1.2-2' }}
          </span>
        </div>
        <ag-grid-angular [gridOptions]="this.gridOptions" class="ag-theme-balham-dark"
                         style="width: 100%; height: 100%;">
        </ag-grid-angular>
      </div>
    
    </div>
    
    <div [ngClass]="{'collapsed': !this.putsSidePanelVisible}" class="side-panel puts">
      <ng-container *ngTemplateOutlet="sidePanel; context: {$implicit: {header: 'PUTS', targetSide: 'puts' }}">
      </ng-container>
    </div>
  
  </div>

</div>

<ng-template #skewIndicator let-ctx>
  <span class="skew-box"
        [class.collapsed-skew-box]="ctx.collapsed"
        [class.skew-meter-loading]="ctx.side === 'calls' ? this.skewMeterCallLoading : this.skewMeterPutLoading">
    <dx-load-indicator width="8" height="8"
                       [visible]="ctx.side === 'calls' ? this.skewMeterCallLoading : this.skewMeterPutLoading">
    </dx-load-indicator>
    <ng-container *ngIf="!(ctx.side === 'calls' ? this.skewMeterCallLoading : this.skewMeterPutLoading)">
      {{ (ctx.side === 'calls' ? this.skewMeterCallSkew : this.skewMeterPutSkew) != null
         ? (ctx.side === 'calls' ? this.skewMeterCallSkew : this.skewMeterPutSkew)
         : 'N/A' }}
    </ng-container>
  </span>
</ng-template>

<!-- IV reading (bare percent — identification is the % format + the tooltip; the old
     toolbar box's loading and N/A-on-error states are preserved). Both modes. -->
<ng-template #ivIndicator let-ctx>
  <span [ngClass]="ctx.collapsed ? 'collapsed-skew-box' : 'skew-box'"
        [class.iv-error]="this.ivError"
        *ngIf="this.ivLoading || this.impliedVolatility != null || this.ivError"
        title="Implied Volatility">
    <dx-load-indicator width="8" height="8" [visible]="this.ivLoading"></dx-load-indicator>
    <ng-container *ngIf="!this.ivLoading">
      {{ this.impliedVolatility != null ? (this.impliedVolatility | percent:'1.1-1') : 'N/A' }}
    </ng-container>
  </span>
</ng-template>

<ng-template #sidePanel let-ctx>
  
  <div *ngIf="!this.isSidePanelVisible(ctx.targetSide)" class="content empty">
    <!-- Collapsed strip: the three readings stack top-down (IV / H-Skew / V-Skew,
         display-only when collapsed); clicking ANYWHERE on the strip expands the side
         (owner, 2026-07-02 R9). -->
    <div (click)="this.toggleSidePanel(ctx.targetSide)" class="side-header collapsed">
      <ng-container *ngTemplateOutlet="ivIndicator; context: { $implicit: { collapsed: true } }"></ng-container>
      <span class="collapsed-skew-box" *ngIf="this.tradingInstrument" title="Horizontal Skew">
        <dx-load-indicator width="8" height="8" [visible]="this.hSkewLoading"></dx-load-indicator>
        <ng-container *ngIf="!this.hSkewLoading">{{ this.hSkewDisplay }}</ng-container>
      </span>
      <ng-container *ngTemplateOutlet="skewIndicator; context: { $implicit: { side: ctx.targetSide, collapsed: true } }"></ng-container>
      <p>{{ ctx.header }}</p>
    </div>
  </div>

  <div *ngIf="this.isSidePanelVisible(ctx.targetSide)" class="content">
    <!-- Reading order (calls, left→right): IV · label · H-Skew · V-Skew; the puts side
         renders the SAME DOM mirrored via .puts-side (row-reverse). Only the LABEL
         collapses the side (owner, 2026-07-02 R9); the H-Skew box opens its overlay. -->
    <div class="side-header">
      <div class="side-header-content" [class.puts-side]="ctx.targetSide === 'puts'">
        <ng-container *ngTemplateOutlet="ivIndicator; context: { $implicit: { collapsed: false } }"></ng-container>
        <p (click)="this.toggleSidePanel(ctx.targetSide)">{{ ctx.header }}</p>
        <ets-horizontal-skew-panel-indicator
            *ngIf="this.tradingInstrument"
            [displayName]="this.tradingInstrument?.displayName">
        </ets-horizontal-skew-panel-indicator>
        <ng-container *ngTemplateOutlet="skewIndicator; context: { $implicit: { side: ctx.targetSide, collapsed: false } }"></ng-container>
      </div>
    </div>
    
    <ng-container *ngIf="this.mode === 'pmd'">
      
      <hr class="separator">
      
      <div class="hedge-selector">
        
        <div class="title">
          <div class="cal" *ngIf="this.mode === 'pmd' && this.pmdHedgeMode === 'custom'">
            <dx-button (click)="this.toggleCalendarizedCustomHedge(ctx.targetSide)"
                       [type]="this.isPmdCustomHedgeCalendarized(ctx.targetSide) ? 'success' : 'normal'"
                       icon="event">
            </dx-button>
          </div>
          <div class="text">{{ this.getHedgesSectionTitle(ctx.targetSide) }}</div>
          <div (click)="this.onChangeHedgesModeClicked(ctx.targetSide)" class="icon">
            <i class="fas fa-exchange-alt fa-sm"></i>
          </div>
        </div>
        
        <div [style.display]="this.getPmdHedgeMode(ctx.targetSide) === 'existing' ? 'block':'none'" class="existing">
          
          <div class="portfolio">
            <div [class.right]="ctx.targetSide === 'puts'" class="label">
              Select Portfolio
            </div>
            
            <div class="input">
              <dx-select-box
                (valueChange)="this.onPortfolioSelecting($event, ctx.targetSide)"
                [displayExpr]="'name'"
                [grouped]="true"
                [items]="this.portfolioList"
                [value]="this.getSelectedPortfolio(ctx.targetSide)"
                fieldTemplate="field"
              >
                <div *dxTemplate="let data of 'field'">
                  <div>
                    <dx-text-box [readOnly]="true"
                                 [value]="data && data.userName + '  |  ' + data.name"
                                 placeholder="Select portfolio...">
                    </dx-text-box>
                  </div>
                </div>
              </dx-select-box>
            </div>
          </div>
          
          <div class="hedge">
            <div [class.right]="ctx.targetSide === 'puts'" class="label">
              Select Hedge
            </div>
            <div [class.right]="ctx.targetSide === 'puts'" class="input">
              <div class="selector">
                <dx-select-box (onValueChanged)="this.onHedgeSelected($event, ctx.targetSide)"
                               [displayExpr]="'label'"
                               [items]="this.getHedgesList(ctx.targetSide)"
                               [value]="this.getSelectedHedge(ctx.targetSide)"
                               placeholder="Hedge"
                >
                </dx-select-box>
              </div>
              <div [class.credit]="this.getHedgesCost(ctx.targetSide) > 0"
                   [class.debit]="this.getHedgesCost(ctx.targetSide) < 0"
                   class="price"
              >
                {{
                      this.getHedgesCost(ctx.targetSide)
                          | currency:'USD':'symbol':'1.2-2'
                }}
              </div>
            </div>
          </div>
        </div>
        
        <div [style.display]="this.getPmdHedgeMode(ctx.targetSide) === 'existing' ? 'none':'block'" class="manual">
          
          <div class="legs-list">
            
            <div class="leg header">
              <div class="block side">Side</div>
              <div class="block qty">Qty</div>
              <div class="block strike">Strike</div>
              <div class="block offset" *ngIf="this.isPmdCustomHedgeCalendarized(ctx.targetSide)">Offset</div>
              <div (click)="this.removeCustomLeg(null, ctx.targetSide)" class="block remove">
                <i class="far fa-trash-alt fa-xs"></i>
              </div>
            </div>
            
            <div *ngFor="let leg of this.getCustomLegs(ctx.targetSide)" class="leg">
              <div class="block side">
                <dx-select-box [(value)]="leg.side"
                               [displayExpr]="'name'"
                               [inputAttr]="this.getStyleForCustomLegSide(leg)"
                               [items]="this.customLegSideList"
                >
                  <div *dxTemplate="let data of 'item'">
                      <span [style.color]="data?.name === 'Buy' ? 'cornflowerblue' : 'red'"> {{ data?.name }}
                      </span>
                  </div>
                </dx-select-box>
              </div>
              <div class="block qty">
                <dx-number-box [(value)]="leg.qty"
                               [inputAttr]="{style: 'text-align: center'}"
                               [min]="1"
                ></dx-number-box>
              </div>
              <div class="block strike">
                <ets-strikes-dropdown [(strike)]="leg.strike"
                                      [expiration]="this.selectedExpiration"
                                      [targetInstrument]="this.tradingInstrument"
                ></ets-strikes-dropdown>
              </div>
              <div class="block offset" *ngIf="this.isPmdCustomHedgeCalendarized(ctx.targetSide)">
                <dx-text-box [inputAttr]="{style: 'text-align: center;'}"
                             [value]="this.getExpirationOffset(leg)"
                             (onValueChanged)="this.setExpirationOffset(leg, $event)"
                ></dx-text-box>
              </div>
              <div (click)="this.removeCustomLeg(leg, ctx.targetSide)" class="block remove">
                <i class="far fa-trash-alt fa-sm"></i>
              </div>
            </div>
          </div>
          
          <hr [style.width.%]="30" class="separator">
          
          <div>
            <dx-button (onClick)="this.addCustomLeg(ctx.targetSide)" text="Add Leg" width="100%"></dx-button>
          </div>
        </div>
      
      </div>
    
    </ng-container>
    
    <hr class="separator">
    
    <div class="strategies-list">
      
      <dx-scroll-view [direction]="'vertical'">
        <div class="scroll-container">
          <div class="template">
            <p class="label">Load Template</p>
            <div class="controls">
              <div class="template-list">
                <dx-select-box
                  (onValueChanged)="this.onTemplateSelected(ctx.targetSide, $event)"
                  [grouped]="true"
                  [items]="this.getGroupedTemplates(ctx.targetSide)"
                  [showClearButton]="true"
                  [value]="ctx.targetSide === 'calls' ? this.callsSelectedTemplate : this.putsSelectedTemplate"
                  displayExpr="templateName"
                  placeholder="Template"
                >
                </dx-select-box>
              </div>
              <div class="template-controls">
                <div class="template-save icon">
                  <dx-button
                    (onClick)="this.newTemplate(ctx.targetSide)"
                    [disabled]="!this.canNewTemplate(ctx.targetSide)"
                    text="New"
                    type="success"
                    width="100%"
                  >
                  </dx-button>
                </div>
                <div class="template-save icon">
                  <dx-button
                    (onClick)="this.saveTemplate(ctx.targetSide)"
                    [disabled]="!this.canSaveTemplate(ctx.targetSide)"
                    text="Save"
                    type="default"
                    width="100%"
                  >
                  </dx-button>
                </div>
                <div class="template-rename icon">
                  <dx-button
                    (onClick)="this.editTemplate(ctx.targetSide)"
                    [disabled]="!this.canRenameTemplate(ctx.targetSide)"
                    text="Edit"
                    width="100%"
                  >
                  </dx-button>
                </div>
                <div class="template-remove icon">
                  <dx-button
                    (onClick)="this.removeTemplate(ctx.targetSide)"
                    [disabled]="!this.canRemoveTemplate(ctx.targetSide)"
                    text="Delete"
                    type="danger"
                    width="100%"
                  >
                  </dx-button>
                </div>
              </div>
            </div>
          </div>
          
          <hr class="template-separator">
          
          <div class="apply-all">
            <div class="apply">
              <dx-button
                (onClick)="this.applyAllStrategies(ctx.targetSide)"
                [disabled]="!this.canApplyAllStrategies(ctx.targetSide)"
                text="Apply All Strategies"
                type="default"
                width="100%">
              </dx-button>
            </div>
            <div class="live">
              <dx-check-box (valueChange)="this.setLiveStatus(ctx.targetSide, $event)"
                            [value]="this.getLiveStatus(ctx.targetSide)"
                            text="Live"
              ></dx-check-box>
            </div>
          </div>
          
          <hr class="template-separator">
          
          <div *ngFor="let strategy of this.getGridStrategies(ctx.targetSide); index as i" class="comparison-strategy">
            
            <div class="header">
              <div>
                <h4 (dblclick)="strategy.onHeaderDblClick($event)"
                    *ngIf="!strategy.isEditingHeader"
                >
                  {{ strategy.strategyName }}
                </h4>
                
                <div style="margin-bottom: 5px;">
                  <dx-text-box
                      #iam
                      (onBlur)="strategy.onHeaderCancelEditing()"
                      (onInitialized)="strategy.onHeaderTextBox(iam)"
                      (onKeyUp)="strategy.onTextBoxKeyUp($event, iam.text)"
                      (onValueChanged)="strategy.onHeaderChanged($event)"
                      *ngIf="strategy.isEditingHeader"
                      [inputAttr]="{'style': 'text-align: center'}"
                      [value]="strategy.strategyName">
                  </dx-text-box>
                </div>
              </div>
            </div>
            
            <div class="controls">
              <div class="block leg-buttons">
                <div class="btn add-leg">
                  <dx-button (onClick)="strategy.addLeg()"
                             [disabled]="!this.tradingInstrument || !this.selectedExpiration" hint="Add Leg"
                             icon="add">
                  </dx-button>
                </div>
                <div class="btn reverse">
                  <dx-button (onClick)="strategy.reverseLegsSide()" [disabled]="strategy.strategyLegs.length === 0"
                             hint="Reverse Side"
                             icon="pulldown">
                  </dx-button>
                </div>
              </div>
              
              <div class="block strategy">
                <dx-select-box
                  (onValueChanged)="strategy.onStrategySelected($event)"
                  [(value)]="strategy.selectedStrategy"
                  [dataSource]="this.strategiesList"
                  [disabled]="!this.tradingInstrument || !this.selectedExpiration"
                  [grouped]="true"
                  [showClearButton]="true"
                  displayExpr="strategy" placeholder="Strategy" valueExpr="strategy">
                </dx-select-box>
              </div>
              
              <div class="block width ets-dx-number">
                <dx-number-box [(value)]="strategy.width" [showSpinButtons]="true" [step]="this.strikeLadderStep" [min]="this.strikeLadderStep" placeholder="Width">
                </dx-number-box>
              </div>
            </div>
            
            <div class="table legs">
              
              <div class="row header">
                <div class="cell remove">
                  <dx-button (click)="this.toggleCalendarized(strategy)" [type]="strategy.calendarized ? 'success' : 'normal'"
                             icon="event">
                  </dx-button>
                </div>
                <div class="cell side">Side</div>
                <div class="cell qty">Qty/Width</div>
                <div class="cell width">Exp. Offset</div>
              </div>
              
              <div *ngFor="let leg of strategy.strategyLegs" class="row leg">
                
                <div [style.visibility]="leg.type === 'width' ? 'hidden' : 'visible'" class="cell remove">
                  <i (click)="strategy.removeLeg(leg)" *ngIf="leg.type === 'leg'"
                     class="far fa-trash-alt icon"></i>
                </div>
                
                <div [style.visibility]="leg.type === 'width' ? 'hidden' : 'visible' " class="cell side">
                  <dx-select-box (onValueChanged)="strategy.onSomethingChanged()" *ngIf="leg.type === 'leg'"
                                 [(value)]="leg.side" [dataSource]="['Buy', 'Sell']"
                                 [inputAttr]="{style: this.getLegColor(leg)}"
                  >
                    <div *dxTemplate="let data of 'item'">
                      <span [style.color]="data === 'Buy' ? 'cornflowerblue' : 'red'"> {{ data }}
                      </span>
                    </div>
                  </dx-select-box>
                </div>
                
                <div *ngIf="leg.type === 'leg'" class="cell qty ets-dx-number">
                  <dx-number-box
                    (onValueChanged)="strategy.onSomethingChanged()" *ngIf="leg.type === 'leg'"
                    [(value)]="leg.qty" [inputAttr]="{'style': 'text-align: center'}" [min]="1"
                    [showSpinButtons]="true"
                    [step]="1"
                    [useLargeSpinButtons]="false">
                  </dx-number-box>
                </div>
                
                <div *ngIf="leg.type === 'width'" class="cell width">
                  <dx-number-box
                    (onValueChanged)="strategy.onWidthChanged()"
                    [(value)]="leg.width"
                    [inputAttr]="{'style': 'text-align: center; font-style: oblique; color: dimgray;'}"
                    [min]="this.strikeLadderStep"
                    [step]="this.strikeLadderStep"
                    [showSpinButtons]="true"
                    [useLargeSpinButtons]="false"
                  >
                  </dx-number-box>
                </div>
                
                
                <div [style.visibility]="this.isExpOffsetVisible(leg, strategy) " class="cell exp-offset">
                  <dx-text-box [inputAttr]="{style: 'text-align: center;'}"
                               [value]="this.getExpirationOffset(leg)"
                               (onValueChanged)="this.setExpirationOffset(leg, $event, strategy)"
                  ></dx-text-box>

                </div>
              
              </div>
            </div>
            
            <div class="buttons">
              <div class="btn remove">
                <dx-button width="100%" (onClick)="this.removeStrategy(ctx.targetSide,strategy)" text="Remove">
                </dx-button>
              </div>
              
              <div class="btn copy">
                <dx-button width="100%" (onClick)="this.copyStrategy(ctx.targetSide,strategy)" text="Copy"
                  [disabled]="!this.canCopyStrategy(strategy)">
                </dx-button>
              </div>
              
              <div class="btn apply">
                <dx-button
                  width="100%"
                  (onClick)="strategy.applyLegs()"
                  [disabled]="!strategy.canApplyLegs" text="Apply"
                  type="default"
                >
                </dx-button>
              </div>
            </div>
            
            <hr class="strategy-separator">
          
          </div>
          
          <div class="buttons">
            <dx-button (onClick)="this.addStrategy(ctx.targetSide)" text="Add Strategy">
            </dx-button>
            <dx-button (onClick)="this.pasteStrategy(ctx.targetSide)" text="Paste Strategy"
              [disabled]="!this.canPasteStrategy()">
            </dx-button>
          </div>
          
          <ng-container *ngIf="this.showAssignTemplatesButton">
            <hr class="template-separator">
            
            <div class="assign-btn">
              <dx-button text="Assign Templates" (onClick)="this.assignTemplates(ctx.targetSide)"></dx-button>
            </div>
          </ng-container>
          
        </div>
      </dx-scroll-view>
    
    </div>
  </div>
</ng-template>

<dx-load-panel
  [position]="{ my: 'center', at: 'center', of: container }"
  [visible]="isLoading"
>
</dx-load-panel>

<dx-popup
  (onHidden)="this.editTemplatePopupModel.onCancelClicked()"
  [closeOnOutsideClick]="false"
  [visible]="this.editTemplatePopupModel.visible"
  height="150" title="Save As Template"
  width="350"
>
  <div *dxTemplate="let data of 'content'" class="opg-edit-template">
    
    <div class="body">
      <div class="input">
        <dx-text-box
          [(value)]="this.editTemplatePopupModel.templateName"
          placeholder="Template name">
        </dx-text-box>
      </div>
      
      <div class="input" *ngIf="this.showAssignTemplatesButton">
        <dx-check-box [(value)]="this.editTemplatePopupModel.isAssignable"
                      [disabled]="!this.editTemplatePopupModel.canChangeAssignable"
                      text="Is Assignable">
        </dx-check-box>
      </div>
    </div>
    
    <div class="buttons">
      <div class="btn">
        <dx-button (onClick)="this.editTemplatePopupModel.onSaveClicked()" text="Save" width="100%">
        </dx-button>
      </div>
      <div class="btn">
        <dx-button (onClick)="this.editTemplatePopupModel.onCancelClicked()" text="Cancel" width="100%">
        </dx-button>
      </div>
    </div>
  
  </div>
</dx-popup>

<ets-generic-confirmation-dialog
  confirmText="Yes"
  rejectText="No"
  title="Delete Template?"
>
</ets-generic-confirmation-dialog>

<ets-orders-verification-dialog>
</ets-orders-verification-dialog>

<ets-opg-assign-templates>
</ets-opg-assign-templates>

<ets-toolbar-visibility-dialog>
</ets-toolbar-visibility-dialog>

<!-- OPG CoPilot window (CR-20260710-001; host-owned dx-popup, APG/Hedge recipe). The *ngIf gate
     is REQUIRED: with deferRendering=false an ungated popup would instantiate the CoPilot for
     unentitled users AND inside every Position Modifier panel (§10 "no entitlement -> no trace").
     The child stays mounted while hidden — and since A6/WI-15 the CLOSE IS A MINIMIZE: onHidden
     only hides. Questionnaires, results, previews and their borders all survive; the session ends
     only at the CoPilot's own refresh button. (staleChange) carries the grid-drift cue back up so
     the launcher can wear it while the window is shut. -->
<dx-popup #copilotPopupRef
          *ngIf="this.isOpgCoPilotAvailable()"
          [(visible)]="this.copilotPopupVisible"
          [shading]="false"
          [dragEnabled]="true"
          [resizeEnabled]="true"
          [closeOnOutsideClick]="false"
          [deferRendering]="false"
          [showTitle]="true"
          title="ORION (OPG)"
          [width]="this.copilotPopupWidth"
          [height]="this.copilotPopupHeight"
          [minHeight]="240"
          [position]="this.copilotPopupPosition"
          [wrapperAttr]="{class: 'orion-copilot-popup'}"
          (onShown)="this.onCopilotShown()"
          (onHidden)="this.onCopilotHidden()">
  <div *dxTemplate="let data of 'content'" class="opg-copilot-popup-body" style="height: 100%;">
    <ets-opg-copilot [root]="this"
                     (contentHeightChange)="this.onCopilotContentHeight($event)"
                     (widthModeChange)="this.onCopilotWidthModeChange($event)"
                     (staleChange)="this.onCopilotStaleChange($event)"
                     (closeRequested)="this.onCopilotHidden()"></ets-opg-copilot>
    <!-- Window zoom sidebar + ear drag handle (shared ORION chrome, owner 2026-08-31: "this zoom
         hatch needs to be implemented for every copilot"). Authored inside the content template
         (Angular owns the bindings) but RELOCATED onto .dx-overlay-content on popup shown
         (OrionWindowController.apply). Mechanics documented in copilot-shared/orion-window.controller.ts. -->
    <div class="orion-zoom-strip"
         [style.transform]="'scale(' + (1 / this.copilotZoomLevel) + ')'"
         (pointerdown)="this.onCopilotZoomStripPointerDown($event)"
         (dblclick)="this.onCopilotZoomStripDblClick($event)">
      <div class="btn" (click)="this.copilotZoomIn()">+</div>
      <div class="pct" title="Double-click to reset to 100%">{{this.copilotZoomPct}}%</div>
      <div class="btn" (click)="this.copilotZoomOut()">-</div>
    </div>
  </div>
</dx-popup>

